import {useEffect, useRef} from "react";

import {IUseReservationFlowResult} from "../types/IUseReservationFlow";
import {ReservationStepName} from "../types/ReservationStepName";
import {getReservationCodeStepContentView} from "../utils/get_reservation_code_step_view";
import {ReservationCodeStepContent} from "./ReservationCodeStepContent";
import {ReservationConfirmedStepContent} from "./ReservationConfirmedStepContent";

interface IProps {
    step: ReservationStepName;
    titleId: string;
    descriptionId: string;
    codeStepProps: IUseReservationFlowResult["codeStepProps"];
    confirmedStepProps: IUseReservationFlowResult["confirmedStepProps"];
    // the close button of a failure that cannot be retried
    onClose: () => void;
    // ROZUMIEM of the confirmation
    onConfirmedClose: () => void;
}

// The body of a host modal on the reservation steps - header, back and close controls stay with the host
export const ReservationStepsContent = (props: IProps) => {
    const {step, titleId, descriptionId, codeStepProps, confirmedStepProps, onClose, onConfirmedClose} = props;

    const contentRef = useRef<HTMLDivElement>(null);
    // each screen replaces the control that had the focus, so the focus has to be kept inside the dialog
    const focusScreen = step === "confirmed" ? step : getReservationCodeStepContentView(codeStepProps).kind;

    useEffect(() => {
        // the code inputs and the name field take the focus themselves - the dialog gets it only when nothing inside holds it
        const dialog = contentRef.current?.closest<HTMLElement>('[role="dialog"]');

        if (dialog && !dialog.contains(document.activeElement)) {
            dialog.focus({preventScroll: true});
        }
    }, [focusScreen]);

    return (
        <div ref={contentRef}>
            {step === "confirmed" ? (
                <ReservationConfirmedStepContent {...confirmedStepProps} titleId={titleId} descriptionId={descriptionId} onClose={onConfirmedClose} />
            ) : (
                <ReservationCodeStepContent {...codeStepProps} titleId={titleId} descriptionId={descriptionId} onClose={onClose} />
            )}
        </div>
    );
};
import {useEffect, useRef} from "react";

import {IUseReservationFlowResult} from "../types/IUseReservationFlow";
import {ReservationStepName} from "../types/ReservationStepName";
import {getReservationCodeStepContentView} from "../utils/get_reservation_code_step_view";
import {ReservationCodeStepContent} from "./ReservationCodeStepContent";
import {ReservationConfirmedStepContent} from "./ReservationConfirmedStepContent";

interface IProps {
    step: ReservationStepName;
    titleId: string;
    descriptionId: string;
    codeStepProps: IUseReservationFlowResult["codeStepProps"];
    confirmedStepProps: IUseReservationFlowResult["confirmedStepProps"];
    // the close button of a failure that cannot be retried
    onClose: () => void;
    // ROZUMIEM of the confirmation
    onConfirmedClose: () => void;
}

// The body of a host modal on the reservation steps - header, back and close controls stay with the host
export const ReservationStepsContent = (props: IProps) => {
    const {step, titleId, descriptionId, codeStepProps, confirmedStepProps, onClose, onConfirmedClose} = props;

    const contentRef = useRef<HTMLDivElement>(null);
    // each screen replaces the control that had the focus, so the focus has to be kept inside the dialog
    const focusScreen = step === "confirmed" ? step : getReservationCodeStepContentView(codeStepProps).kind;

    useEffect(() => {
        // the code inputs and the name field take the focus themselves - the dialog gets it only when nothing inside holds it
        const dialog = contentRef.current?.closest<HTMLElement>('[role="dialog"]');

        if (dialog && !dialog.contains(document.activeElement)) {
            dialog.focus({preventScroll: true});
        }
    }, [focusScreen]);

    return (
        <div ref={contentRef}>
            {step === "confirmed" ? (
                <ReservationConfirmedStepContent {...confirmedStepProps} titleId={titleId} descriptionId={descriptionId} onClose={onConfirmedClose} />
            ) : (
                <ReservationCodeStepContent {...codeStepProps} titleId={titleId} descriptionId={descriptionId} onClose={onClose} />
            )}
        </div>
    );
};
